<template>
  <div>
    <papel-seguranca-consumo v-if="modal.consumo.show"
                             :prop-registro-id="registro_id"
                             :prop-selo="selectSelo"
                             :prop-tipo-papel="propTipoPapel"
                             @onHide="(item) => hidePapelSegurancaConsumo(item)" />

    <impressao-ordem-servico v-if="tela_ordem_servico"
                             :ordem-servico="ordensServico"
                             :prop-imprimir-os="propImprimirOs"
                             :prop-pedido-pendente="propPedidoPendente"
                             @OnChangeTelaOrdemServico="changeTelaImpressao"
                             @onSelectOrdemServico="selectOrdemServico" />

    <div v-if="!tela_ordem_servico">
      <sub-header-grey>
        <div class="no-gutters d-flex justify-content-between pb-2 pl-2">
          <div id="div-seloid"
               class="col-md-5 col-sm-7">
            <!--<b-form-select v-model="selectSelo"
                           :options="optionsSelos"
                           size="sm"
                           @change="onSelectSelo">
              <template v-slot:first>
                <option :value="null"
                        disabled>
                  &#45;&#45; Minutas &#45;&#45;
                </option>
              </template>
            </b-form-select>-->

            <b-form-select v-if="optionsSelos.length > 0"
                           id="optionsSelos"
                           v-model="selectSelo"
                           class="form-control form-control-sm"
                           name="optionsSelos"
                           label="num_selo"
                           size="sm"
                           @input="onSelectSelo">
              <option v-for="(optionSelo, index) in optionsSelos"
                      :key="'option_selo_'+index"
                      :value="optionSelo">
                Tipo: {{ optionSelo.tipo_ato }} - Selo: {{ optionSelo.num_selo }}
              </option>

              <!-- <template #selected-option="{ tipo_ato, num_selo }">
                Tipo: {{ tipo_ato }} - Selo: {{ num_selo }}
              </template>

              <template #option="{ tipo_ato, num_selo }">
                Tipo: {{ tipo_ato }} - Selo: {{ num_selo }}
              </template> -->
            </b-form-select>
          </div>

          <div v-if="optionsSelos.length > 0"
               id="div-btn-url-qrcode">
            <button id="btn-copy-qrcode"
                    class="btn btn-sm btn-secondary"
                    @click="copyQrcodeUrl">
              Copiar a URL do QRCode
            </button>
            <b-tooltip :show.sync="showTooltip"
                       target="btn-copy-qrcode"
                       title="URL do QRCode copiada!"
                       triggers="click"
                       @shown="hideTooltipLater">
              URL do QRCode copiada!
            </b-tooltip>
          </div>
          <div :id="optionsSelos.length > 0 ? 'div-btn-export-certidao' : 'div-btn-export-certidao-v2'">
            <button id="btn-export-certidao"
                    class="btn btn-sm btn-secondary"
                    :disabled="selectMinuta !='certidao' && selectMinuta != 'inteiro_teor_1'"
                    @click="gerarJson(impressao, selectMinuta)">
              Exportar Json {{ selectMinuta == "certidao" ? "- Certidão" : selectMinuta == "inteiro_teor_1" ? "- Inteiro Teor" : selectMinuta == "certidao_eletronica"? "- Certidão Eletrônica": "" }}
            </button>
          </div> 
          <div>
            <b-form-select id="selectMinutas"
                           v-model="selectMinuta"
                           name="selectMinutas"
                           :options="optionsMinuta"
                           size="sm"
                           @change="getSelo(), minutaLoad()">
              <template v-slot:first>
                <option :value="null"
                        disabled>
                  -- Minutas --
                </option>
              </template>
            </b-form-select>
          </div>
        </div>
      </sub-header-grey>

      <div class="container">
        <div v-if="selectMinuta == 'certidao'">
          <!--<formulario-impressao :data="obito"
                                @onChangeImpressao="changeImpressao" />-->

          <impressao-formulario-obito v-if="tipo == 'obito'"
                                      :data="localData"
                                      :cartorio-obj="cartorio"
                                      :orgao-emissor="orgaoEmissor"
                                      :prop-averbacoes="averbacoes"
                                      @onChangeImpressao="changeImpressao" />

          <impressao-formulario-nascimento v-if="tipo == 'nascimento'"
                                           :data="localData"
                                           :cartorio-obj="cartorio"
                                           :prop-averbacoes="averbacoes"
                                           :prop-orgao-emissor="orgaoEmissor"
                                           @onChangeImpressao="changeImpressao" />

          <impressao-formulario-habilitacao v-if="tipo == 'habilitacao' && show"
                                            :prop-data="localData"
                                            :prop-impressao="impressao"
                                            :prop-ordem-servico="ordemServicoSelected"
                                            @onVisualizar="visualizar($event)"
                                            @onChangeImpressao="changeImpressao" />

          <impressao-formulario-casamento v-if="tipo === 'casamento'"
                                          :prop-casamento="localData"
                                          :prop-averbacoes="averbacoes"
                                          :prop-orgao-emissor="orgaoEmissor"
                                          @changeImpressao="changeImpressao" />

          <anotacoes-cadastro v-if="tipo != 'habilitacao'"
                              :registro-id="registro_id"
                              :prop-registro="localData.registro"
                              @onNovaAnotacao="novaAnotacao" />

          <div id="assinatura_certidao">
            <sub-header-grey class="row mt-1 mb-1">
              <div class="d-flex justify-content-between pb-1 pl-2">
                Assinatura de Certidão
              </div>
            </sub-header-grey>

            <b-row>
              <div class="col-5">
                <label class="impressao--label"
                       for="">
                  Assinante da certidão:
                </label>
                <b-form-select v-model="impressao.assinante"
                               v-validate="'required'"
                               class="mb-3"
                               :class="{'is-invalid':errors.has('assinante')}"
                               name="assinante"
                               size="sm"
                               @change="changeImpressao(impressao)">
                  <template v-slot:first>
                    <option :value="null"
                            disabled>
                      -- Selecione uma opção --
                    </option>
                  </template>
                  <option v-for="(assinante,index) in assinantes"
                          :key="'assinante_'+index"
                          :value="assinante">
                    {{ assinante.nome }}
                  </option>
                </b-form-select>
              </div>
              <div class="col-3">
                <label class="impressao--label"
                       for="">
                  Data da certidão:
                </label>
                <input v-model="dataAtual"
                       type="date"
                       class="form-control form-control-sm"
                       @change="changeImpressao()">
              </div>
            </b-row>
          </div>

          <hr>
          <div class="text-right">
            <button class="btn btn-sm btn-default mr-2"
                    :disabled="tela_ordem_servico"
                    @click="voltar()">
              Voltar
            </button>

            <b-dropdown size="sm"
                        right
                        split
                        text="Pré Visualizar"
                        @click="visualizar(impressao)">
              <b-dropdown-item @click="visualizar(impressao)">
                Pré Visualizar
              </b-dropdown-item>
              <b-dropdown-item @click="imprimir()">
                Imprimir
              </b-dropdown-item>
              <!-- <b-dropdown-item @click="gerarXML(impressao, tipo)">
                Gerar XML
              </b-dropdown-item> -->
              <!-- <b-dropdown-item  v-if="!!localData && !!localData.registro.documentoCertidaoEletronica"
                @click="visualizarCertidao(localData.registro.documentoCertidaoEletronica)">
                Visualizar Certidão Eletronica
              </b-dropdown-item> -->
              <b-dropdown-item
                v-if="tipo !== 'habilitacao'"
                @click="gerarCertidao(impressao)">
                Gerar Certidão Eletrônica
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>

        <div v-if="selectMinuta == 'capa_e-habilitacao'">
          <object v-if="pdfPreview != null"
                  class="Impressao--pdfPreview"
                  :data="pdfPreview"
                  type="application/pdf">
            <p>Seu browser não suporta arquivos pdf diretamente ou este arquivo não existe. Você pode tentar efetuar o download clicando.</p>
          </object>
          <hr>
          <div class="text-right">
            <b-dropdown size="sm"
                        right
                        split
                        text="Imprimir"
                        @click="openPreviewPdf()">
              <b-dropdown-item @click="openPreviewPdf()">
                Imprimir
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>

        <div v-else-if="selectMinuta.match('inteiro_teor') && showInteiroTeor">
          <ImpressaoInteiroTeor ref="componenteInteiroTeor"
                                :prop-tipo-registro="localData.registro.tipo_registro"
                                :prop-tipo-registro-extenso="this.tipo"
                                :prop-data-pessoas="this.data.registro.pessoas"
                                :prop-registro-id="this.data.registro.registro_id"
                                :prop-impressao="impressao"
                                :prop-assinantes="assinantes"
                                :prop-averbacoes="averbacoes"
                                :prop-registro="data.registro"
                                :prop-inteiro-teor="inteiroTeor"
                                @imprimir="imprimir"
                                @changeImpressao="changeImpressao"
                                @visualizar="visualizar"
                                @voltar="voltar()" />
        </div>

        <div v-else-if="selectMinuta != 'certidao'">
          <div id="termo-editor">
            <termo-tela v-if="html"
                        :data="localData"
                        :tipo="tipo"
                        :html="html"
                        :assinantes="assinantes"
                        :impressao="impressao"
                        :zoom="zoom"
                        :select-minuta="selectMinuta"
                        @onZoom="zoomUpdate"
                        @onChangeOrdemServico="tela_ordem_servico=!tela_ordem_servico"
                        @onVisualizar="visualizar"
                        @onUpdateHtml="updateHtml"
                        @onImprimir="imprimir"
                        @onGerarCertidao="gerarCertidao(impressao)"
                        @changeImpressao="changeImpressao, minutaLoad()" />
          </div>
        </div>
      </div>
    </div>

    <modal-certidao :data="{ ...impressao, ordemServicoSelected }"
                    :tipo="tipo"
                    :zoom="zoom"
                    :prop-file-preview="filePreview"
                    @onImprimir="imprimir" />

    <modal-memorial-aditivo :data="impressao"
                            :tipo="tipo"
                            :zoom="zoom"
                            :prop-file-preview="filePreview"
                            @onImprimir="imprimir" />

    <modal-termo :html="htmlPreview"
                 :zoom="zoom"
                 @onImprimir="imprimir" />

    <ModalInteiroTeor :data="impressao"
                      :tipo="tipo" />

    <modal-certidao-eletronica :data="{ urlPDFCertidao, certidaoEletronicaId }"
                               :zoom="zoom"
                               :prop-file-preview="filePreview"
                               @onAssinar="assinarCertidaoEletronica" />
    <!--    <b-modal v-model="modal.hipossuficiencia.show"
             centered
             hide-footer
             no-close-on-backdrop
             hide-header
             no-close-on-esc
             title="Atenção">
      <h4>Atenção</h4>
      <p class="my-4">
        <span class="custom-control custom-switch">
          <input
            id="declaracao_de_hipossuficiencia"
            v-model="modal.hipossuficiencia.declaracao_pobreza"
            class="custom-control-input"
            name="hipossuficiencia"
            type="checkbox"
            @change="verifyHipossuficiencia()">
          <label
            class="custom-control-label"
            for="declaracao_de_hipossuficiencia">Adicionar Declaração de Hipossuficiência</label>
        </span>
      </p>
      <hr>
      <div class="text-right">
        <button class="btn btn-sm btn-secondary"
                @click="modal.hipossuficiencia.show = false">
          Fechar
        </button>
      </div>
    </b-modal>-->
  </div>
</template>

<script>
  /* components */
  import AnotacoesCadastro from "./Tipos/Certidao/AnotacoesCadastro"
  import ImpressaoOrdemServico from "@/components/SofiaRei/Resumo/Impressao/ImpressaoOrdemServico"
  import ModalCertidao from "./Tipos/Certidao/ModalCertidao"
  import ModalMemorialAditivo from "./Tipos/Certidao/ModalMemorialAditivo"
  import ModalTermo from "./Tipos/Termo/ModalTermo"
  import SubHeaderGrey from "@/components/SofiaRei/Headers/SubHeaderGrey"
  import TermoTela from "./Tipos/Termo/TermoTela"
  import ImpressaoFormularioObito
    from "@/components/SofiaRei/Resumo/Obito/ImpressaoFormularioObito"
  import ImpressaoFormularioNascimento
    from "@/components/SofiaRei/Resumo/Nascimento/ImpressaoFormularioNascimento"
  import ImpressaoFormularioHabilitacao from "@/components/SofiaRei/Resumo/Habilitacao/ImpressaoFormularioHabilitacao"
  import ImpressaoFormularioCasamento from "@/components/SofiaRei/Resumo/Casamento/ImpressaoFormularioCasamento"
  import PapelSegurancaConsumo from "@/components/SofiaRei/PapelSeguranca/PapelSegurancaConsumo"
  import ImpressaoInteiroTeor from '@/components/SofiaRei/InteiroTeor/ImpressaoInteiroTeor.vue'
  import ModalInteiroTeor from '@/components/SofiaRei/InteiroTeor/ModalInteiroTeor.vue'
  import ModalCertidaoEletronica from "./Tipos/Certidao/ModalCertidaoEletronica"
  import CertidoesCRCService from '@/services/CertidoesCRCService'

  /* services */
  import UsuarioService from "@/services/Auth/UsuarioService"
  import CartorioService from "@/services/CartorioService"
  import AverbacoesService from "@/services/Registros/AverbacoesService"
  import HabilitacaoService from "@/services/Registros/Habilitacao"
  import ImpressaoService from "@/services/Registros/ImpressaoService"
  import OrdensServicoService from "@/services/Registros/OrdensServicoService"
  import { rei } from "@/services/api"
  import eHabilitacaoService from "@/services/Registros/Habilitacao/eHabilitacaoService"
  import CartorioConfigService from "@/services/CartorioConfigService"
  import PapelSegurancaLoteItensService from "@/services/PapelSeguranca/PapelSegurancaLoteItensService"
  import ProcedimentoService from "@/services/ProcedimentoService"
  import CustasService from "@/services/Registros/CustasService"
  import CertidaoService from "@/services/Files/CertidaoService.js"
  import ProvimentoTrezeService from "@/services/ProvimentoTrezeService"
  import EProtocoloService from '@/services/EProtocoloService'
  import AuthService from "@/services/Auth/AuthService"

  /* constants */
  import { locaisObitoObj } from '@/constants/locaisObito'
  import { getOrgaoEmissor, getDocumentLabel } from "@/constants/documentosPessoais"
  import {
    CASAMENTO_CIVIL,
    CASAMENTO_RELIGIOSO,
    UNIAO_ESTAVEL,
    EDITAL_OUTRA_SERVENTIA,
    A_VISTA_HABILITACAO,
    CASAMENTO_RELIGIOSO_EFEITO_CIVIL,
    CASAMENTO_CIVIL_OUTRO_CARTORIO,
  } from "@/constants/casamento/tipos"
  import { MINUTAS_PRE_VISUALIZACAO, MINUTAS_IMPRIMIR_RASCUNHO, ADMIN } from "@/constants/permissions"

  /* Filters */
  import { maskMatricula } from '@/filters/filterMask'

  /* Helpers */
  import { getEstadoCivilBySexo } from '@/helpers/estadoCivil'
  import DataExtensoHelper from "@/helpers/Datas/DataExtensoHelper"

  /* others */
  import moment from "moment"
  import { mapGetters } from "vuex"
  import { last } from 'pdf-lib'
  import { injectPrintStyles } from '@/utils/printStyles'

  export default {
    name: "Impressao",
    components: {
      ImpressaoFormularioObito,
      AnotacoesCadastro,
      ImpressaoOrdemServico,
      ModalCertidao,
      ModalMemorialAditivo,
      ModalTermo,
      SubHeaderGrey,
      TermoTela,
      ImpressaoFormularioObito,
      ImpressaoFormularioNascimento,
      ImpressaoFormularioHabilitacao,
      ImpressaoFormularioCasamento,
      PapelSegurancaConsumo,
      ImpressaoInteiroTeor,
      ModalInteiroTeor,
      ModalCertidaoEletronica
    },
    props: {
      data: Object,
      tipo: String,
      ordemServico: {type: Array, default: () => [] },
      propImprimirOs: {type: Object, default: () => ({})},
      propMinuta: {type: String, default: () => (null)},
      propTipoPapel: {type: String, default: 'papel_de_seguranca_registro_civil'},
      propPedidoPendente: {type: Object, default: () => {}},
      propPedidoProvimento: {type: Object, default: () => {}},
    },
    provide () {
      return {
        $validator: this.$validator,
      }
    },
    data () {
      return {
        dataAtual: null,
        papelSegurancaLote: false,
        modal: {
          hipossuficiencia: {
            show: false,
            declaracao_pobreza: false
          },
          consumo: {
            show: false,
            item: {}
          }
        },
        CASAMENTO_RELIGIOSO,
        EDITAL_OUTRA_SERVENTIA,
        CASAMENTO_RELIGIOSO_EFEITO_CIVIL,
        CASAMENTO_CIVIL_OUTRO_CARTORIO,
        UNIAO_ESTAVEL,
        registro_id: this.data.registro_id,
        show: false,
        filePreview: null,
        ordensServico: [],
        tela_ordem_servico: true,
        zoom: 0,
        baseUrlRei: rei.defaults.baseURL,
        html: null,
        htmlPreview: null,
        localData: {},
        emolumentos: null,
        ordemServicoSelected: null,
        optionSeloSelected: null,
        selectSelo: {},
        selectMinuta: 'certidao',
        optionsSelos: [],
        optionsMinuta: [],
        minutasObito: [
          { value: 'certidao', text: 'Certidão' },
          { value: 'termo_1', text: 'Termo - 1 ' },
        ],
        minutasNascimento: [
          { value: 'certidao', text: 'Certidão' },
          { value: 'termo_1', text: 'Termo - 1 ' }
        ],
        minutasHabilitacao: [
          { value: 'termo_juntada', text: 'Juntada de Pacto' },
          { value: 'memorial_aditivo', text: 'Memorial Aditivo' }, // especificamos como termo,
          { value: 'capa_e-habilitacao', text: 'Capa E-habilitação' },
          { value: 'termo_edital', text: 'Edital' },
          { value: 'termo_declaracoes', text: 'Declarações' }
        ],
        minutasCasamento: [
          {value: 'certidao', text: 'Certidão'},
          {value: 'termo_1', text: 'Termo - 1'}
        ],
        impressao: {
          anotacoes: [],
          assinante: null,
          averbacoes: null,
          cartorio: null,
          declarante: null,
          dia: null,
          eleitor: null,
          emolumentos: null,
          estado_civil: null,
          filiacao_residencia: null,
          idade: null,
          matricula: null,
          medico_crm: null,
          mes: null,
          naturalidade_declarada: null,
          nome: null,
          rg: null,
          documento_identificacao: null,
          selo: {
            selo_digital: null,
            qr_code: null
          },
          sepultamento_cremacao: null,
          sexo: null,
          oficial: null,
          dados: {}
        },
        assinantes: [],
        averbacoes: [],
        cartorio: {},
        orgaoEmissor: {},
        selos: [],
        parte: null,
        getDocumentLabel,
        MINUTAS_PRE_VISUALIZACAO,
        MINUTAS_IMPRIMIR_RASCUNHO,
        pdfPreview: null, // usado para quando o preview for PDF,
        ADMIN,
        custas: [],
        showTooltip: false,
        procedimentos: [],
        inteiroTeor: {},
        showInteiroTeor: false,
        urlPDFCertidao: null,
        certidaoEletronicaId: null,
        OsComPedidoPendente: false,
        pedidoResponse: {}
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
        user: 'auth/getUser'
      })
    },
    watch: {
      data () {
        this.localData = {...this.data}
        this.init()
        this.changeImpressao()
      },
      ordemServico () {
        this.init()
      },
    },
    created () {
      this.init()
    },
    methods: {
      async init () {
        try {
          loader({ text: "Aguarde...", active: true })

          this.dataAtual = moment().format('YYYY-MM-DD')

          const papelSegurancaLoteStatus = await CartorioConfigService.showByChave({
            chave: 'PAPEL_SEGURANCA_STATUS'
          })

          // deixamos a comparação de valor, para caso não tiver nada, ficar false
          this.papelSegurancaLote = papelSegurancaLoteStatus.valor === '1'

          this.localData = {...this.data}

          if (['C', 'CR', 'D'].indexOf(this.localData.registro.tipo_registro) !== -1) {
            for (const pessoa of this.localData.registro.pessoas) {
              pessoa.estado_civil = getEstadoCivilBySexo(pessoa.estado_civil, pessoa.sexo)

              if (['VIUVA', 'VIUVO'].indexOf(pessoa.estado_civil) != -1) {
                pessoa.estado_civil = pessoa.estado_civil.replace('U', 'Ú')
              }
            }
          } else {
            this.localData.registro.pessoa.estado_civil = getEstadoCivilBySexo(
              this.localData.registro.pessoa.estado_civil,
              this.localData.registro.pessoa.sexo
            )

            if (['VIUVA', 'VIUVO'].indexOf(this.localData.registro.pessoa.estado_civil) != -1) {
              this.localData.registro.pessoa.estado_civil = this.localData.registro.pessoa.estado_civil.replace('U', 'Ú')
            }
          }
          
          switch (this.tipo) {
          case 'obito':
            this.verifyTransporte(this.tipo)
            this.optionsMinuta = this.minutasObito
            break

          case 'nascimento':
            this.verifyTransporte(this.tipo)
            this.getMinutasSupostoPai()
            this.optionsMinuta = this.minutasNascimento
            break

          case 'habilitacao':
            const minutasBkp = [...this.minutasHabilitacao]
            const minutas = []

            if (this.tiposCertidao()) {
              if (moment().isSame(this.data.data_habilitacao) || moment().isAfter(this.data.data_habilitacao)) {
                minutas.push({
                  value: 'certidao',
                  text: 'Certidão'
                }, {
                  value: 'certidao_eletronica',
                  text: 'Certidão Eletrônica'
                }, {
                  value: 'termo_recibo',
                  text: 'Recibo'
                })
              }
            }

            const tipoCasamentoValido = ([CASAMENTO_CIVIL, UNIAO_ESTAVEL, A_VISTA_HABILITACAO, CASAMENTO_CIVIL_OUTRO_CARTORIO].indexOf(this.data.tipo_casamento) < 0)

            if (tipoCasamentoValido && !(minutas.find(minuta => minuta.value === 'certidao'))) {
              minutas.push({
                value: 'certidao',
                text: 'Certidão'
              })
            }

            minutas.push(...minutasBkp)

            this.optionsMinuta = minutas

            this.selectMinuta = this.optionsMinuta[0].value

            this.tratarHabilitacao()
            break

          case 'casamento':
            this.verifyTransporte(this.tipo)
            this.optionsMinuta = this.minutasCasamento
            break
          }
          await this.getOrdensServico()

          await this.getAverbacoes()

          await this.getProcedimentos()

          await this.assinante()

          await this.getCartorio()

          await this.changeImpressao()

          await this.getOrgaoEmissor()

          // Caso a prop de minuta venha preenchida, selecionamos a minuta para depois carregá la
          if (!!this.propMinuta) {
            this.selectMinuta = this.propMinuta

            // Desabilitamos a tela de seleção da ordem de serviço
            this.tela_ordem_servico = false
          }

          this.getSelo()

          await this.minutaLoad()

          await this.verifyPedidoPendente()

          this.show = true
        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        } finally {

          loader({ active: false })
        }
      },
      async getProcedimentos () {
        try {
          loader({ active: true, text: 'Buscando procedimentos...'})

          const res = await ProcedimentoService.getProcedimentos({
            cartorio_id: this.cartorioId, 
            registro_id: this.data.registro_id, 
            acao: 'INTEIRO_TEOR'
          })

          const procedimentos = res && res.length ? [res[res.length - 1]] : []

          if (procedimentos && procedimentos.length) {
            procedimentos.forEach((procedimento, index) => {
              this.minutasObito.push({
                value: `inteiro_teor_${index + 1}`,
                text: `Inteiro Teor - ${index + 1}`
              })

              this.minutasNascimento.push({
                value: `inteiro_teor_${index + 1}`,
                text: `Inteiro Teor - ${index + 1}`
              })

              this.minutasCasamento.push({
                value: `inteiro_teor_${index + 1}`,
                text: `Inteiro Teor - ${index + 1}`
              })
            })
          }

          this.procedimentos = procedimentos
        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({ active: false, text: ''})
        }
      },
      voltar () {
        this.emolumentos = null
        this.impressao.emolumentos = null
        this.tela_ordem_servico = !this.tela_ordem_servico
        this.selos = []

        setTimeout(() => {
          const element = document.getElementById(!!this.ordensServico.length ? 'checkbox_os_0' : 'continuarOrdemServico')

          if (element) element.focus()
        }, 300)
      },
      tiposCertidao () {
        const tipos = [this.CASAMENTO_RELIGIOSO, this.CASAMENTO_RELIGIOSO_EFEITO_CIVIL, EDITAL_OUTRA_SERVENTIA]

        return tipos.includes(this.data.tipo_casamento)
      },
      async getAverbacoes () {
        this.averbacoes = await AverbacoesService.getAverbacaoByRegistroId(this.data.registro_id)
      },
      async assinante () {
        await UsuarioService.getUsuarios().then(res => {
          this.assinantes = res.data
        })
        const user = this.$store.state.auth.usuario

        this.assinantes.forEach(assinante => {
          if (assinante.user_id === user.user_id) {
            this.impressao.assinante = assinante
          }
        })

        this.assinantes = this.assinantes.filter((assinante) => {
          if (assinante.nome.match('SUPORTE') || assinante.nome.match('suporte')) return false
          else return true
        })

        if (!this.impressao.assinante) {
          this.impressao.assinante = this.assinantes.find(assinante => assinante.flag_oficial === 1)
        }
      },
      async getCartorio () {
        await CartorioService.getCartorioRei(this.$store.state.auth.cartorio_id).then(res => {
          this.cartorio = res.data
          this.impressao.cartorio = this.cartorio
          this.impressao.oficial = this.cartorio.nome_oficial
        })
      },
      async getOrdensServico () {
        try {
          loader({text: 'Carregando ordens de serviço...', active: true})
          await OrdensServicoService.getOSByResgitroId(this.data.registro_id).then(response => {
            this.ordensServico = response
          })
        } catch (error) {
          this.displayError('', 'Não foi possível carregar as ordens de serviço.')
        } finally {
          loader({text: 'Carregando ordens de serviço...', active: false})
        }

      },
      async changeImpressao (data = this.impressao) {
        this.show = false
        let { anotacoes, assinante, oficial, emolumentos, selo, cartorio } = this.impressao

        this.impressao = {...data} //passando alteracoes no form para objeto this.impressao

        if (!this.impressao.registro) this.impressao.registro = { ...this.data.registro }

        Object.assign(this.impressao, { anotacoes, assinante, oficial, emolumentos, selo, cartorio })

        // Tratamos o valor dos emolumentos quando o selo selecionado, quando tiver o item da OS zerado
        await this.trataEmolumentosQuandoOsTemItemZerado()

        moment.locale('pt-br')
        this.impressao.data_atual = moment(this.dataAtual).format('DD [de] MMMM [de] YYYY')
        setTimeout(() => {
          this.show = true
        }, 200)
      },
      async trataEmolumentosQuandoOsTemItemZerado () {
        if (
          this.ordemServico &&
          this.ordemServico.length > 0 && // Verifica se this.ordemServico está definido e não vazio
          this.ordemServicoSelected &&
          Object.keys(this.ordemServicoSelected).length > 0 // Verifica se this.ordemServicoSelected está definido e não vazio
        ) {
          const os = this.ordemServicoSelected // Atribui this.ordemServicoSelected a uma variável para facilitar o acesso

          // Verifica se há itens na ordem de serviço selecionada e se algum deles tem valor zerado
          const itemOsSelecionado = Object.values(os.itens).find(itemOS => {
            return itemOS.seloItemOs.find(seloItem => seloItem.selo.num_selo === this.impressao.selo.selo_digital) &&
              itemOS.valor === 0
          })

          if (itemOsSelecionado) {
            // Se houver um item com valor zerado, zera os emolumentos
            this.emolumentos.forEach(emolumento => emolumento.valor = 'R$ 0,00')
            this.impressao.emolumentos = this.emolumentos
          } else {
            const emolumentos = []
            let custaAverbacao = null

            // Caso exista algum item com averbacao buscamos a custa para distribuir durante o calculo
            let itemComAverbacao = os.itens.find(item => item.averbacao > 0)
            if (!!itemComAverbacao) {
              custaAverbacao = await CustasService.getCustaAverbacaoById(itemComAverbacao.custa.custa_info_iss_id)
            }

            // Calcula os emolumentos se nenhum item estiver zerado
            Object.values(os.itens).forEach(item => {
              item.custa.itens.forEach(custaItem => {
                const index = emolumentos.findIndex(emolumento => emolumento.destino === custaItem.destino)
                if (index === -1 && item.averbacao > 0 && !!custaAverbacao) {
                  // Para itens com averbacao
                  let destinatarioAverbacao = custaAverbacao.itens.find((itemAverbacao) => itemAverbacao.destino == custaItem.destino)
                  emolumentos.push({
                    destino: custaItem.destino,
                    valor: +(custaItem.valor + (item.averbacao * destinatarioAverbacao.valor))
                  })
                } 
                else if (index === -1) {
                  // Para itens sem averbacao
                  emolumentos.push({
                    destino: custaItem.destino,
                    valor: +custaItem.valor
                  })
                }
                else {
                  emolumentos[index].valor += +custaItem.valor
                }
              })
            })

            // Converte os valores para Reais
            emolumentos.forEach(emolumento => emolumento.valor = this.centsToReal(emolumento.valor))

            // Adiciona o total dos emolumentos
            const valorTotalEmolumentos = this.centsToReal(os.valor_total)
            emolumentos.push({
              destino: 'Total',
              valor: valorTotalEmolumentos
            })

            // Atualiza os emolumentos
            this.emolumentos = emolumentos
            this.impressao.emolumentos = emolumentos
          }
        }
      },
      centsToReal (cents) {
        return (cents / 100).toLocaleString("pt-BR", {style: "currency", currency: "brl"})
      },
      novaAnotacao (data) {
        let impressao = this.impressao
        this.impressao = {...impressao}
        this.impressao.anotacoes = data
        this.tratarDocumentos()
      },
      impressaoJson () {
        return JSON.stringify(this.impressao)
      },
      async imprimir (data = this.html) {
        // Verificamos a permissão no método pois existem rotas que não podem ser bloqueadas
        // Se for oficial ou suporte não validamos
        const { groups, flag_oficial } = this.user
 
        let login = ''

        if (this.user) {
          login = this.user.login.split('_')[0]
        }

        if (groups && groups.length && !flag_oficial) {
          let access = false
          const permissions = [this.MINUTAS_IMPRIMIR_RASCUNHO, this.ADMIN]

          groups.forEach(group => {
            const permission = !!group.permissions.find(permission => !!permissions.includes(permission.codename))

            if (permission && group.ativo) access = true
          })

          if (!access) {
            return displayMessage('error', 'Acesso negado!', 'Você não tem permissão para acessar essa função.')
          }
        } else if (login !== 'suporte' && !flag_oficial) {
          return displayMessage('error', 'Acesso negado!', 'Você não tem permissão para acessar essa função.')
        }

        if (this.tipo == "habilitacao") {
          if (this.selectMinuta != "certidao" && this.selectMinuta != "memorial_aditivo" && this.selectMinuta != "certidao_eletronica") {
            this.$validator.validate().then(resp => {
              if (resp) {
                this.impressaoTipos().termo({
                  html: data,
                  assinante: this.impressao.assinante,
                  cartorio: this.cartorio,
                  selo_digital: this.impressao.selo.selo_digital,
                  registroId: this.data.registro.registro_id
                })

                return
              } else {
                objSwal.error.title = 'Erro'
                objSwal.error.text = 'Preencha os campos obrigatórios.'

                return Swal.fire(objSwal.error)
              }
            })
          } else if (this.selectMinuta == 'memorial_aditivo' ) {
            try {
              loader({ text: "Preparando download...", active: true })
              const haha = document.querySelector('.pagina-margin').innerHTML
              const pdfFile = await HabilitacaoService.getMemorialPDF(haha)
              let blob = new Blob([pdfFile], { type: 'application/pdf' })
              let url = window.URL.createObjectURL(blob)

              window.open(url)

            } catch (e) {
              console.error('Erro ao realizar download do arquivo PDF', e)
            } finally {
              loader({ active: false })
            }
          } 
          else if (this.selectMinuta == 'certidao_eletronica') {

            const acao = await this.abrirModalCertidaoEletronica()

            if (acao === 'baixar') {
              try {
                loader({ text: "Preparando download...", active: true })

                let html = await this.getHtmlCertidaoEletronica()

                const payloadFinal = {
                  habilitacao: this.localData,
                  impressao: this.impressao,
                  ordemServicoSelected: this.ordemServicoSelected,
                  registroId: this.data.registro.registro_id,
                  html: html
                }

                const pdfFile = await HabilitacaoService.getPdfCertidao(payloadFinal, false)

                const blob = new Blob([pdfFile], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                window.open(url);

              } catch (e) {
                console.error('Erro ao realizar download do arquivo PDF', e);
              } finally {
                loader({ active: false });
              }
            }
          }

          else {
            try {
              this.filePreview = null

              let html = null

              if (document.querySelector('.paste-html')) {
                html = document.querySelector('.paste-html').innerHTML
                html = html.replace(/contenteditable="true"/g, '')
              }

              const statusImpressao = await this.callPapelSegurancaVerify()

              if (!this.papelSegurancaLote && statusImpressao.tipo == 'impressao' || statusImpressao.tipo == 'impressao_rascunho' || (statusImpressao.tipo == 'impressao' && Object.values(statusImpressao.papel).length > 0)) {
                loader({text: "Gerando PDF...", active: true})

                const params = {
                  registroId: this.data.registro.registro_id,
                  tipo_impressao: statusImpressao.tipo
                }

                if (html) {
                  params.html = html
                }

                const pdfFile = await HabilitacaoService.getPdfCertidao(params)

                let blob = new Blob([pdfFile], {type: 'application/pdf'})
                let url = window.URL.createObjectURL(blob)

                window.open(url)
              }

            } catch (e) {
              console.error('Erro ao gerar preview do memorial', e)
              await this.reusePapelSeguranca()
            } finally {
              loader({active: false})
            }
          }
        }

        if (this.tipo != "habilitacao") {
          if (this.selectMinuta === "certidao") {
            this.impressaoTipos().certidao(data)
          } else if (this.selectMinuta.match("inteiro_teor")) {
            this.impressaoTipos().inteiroTeor(data)
          } else {
            this.impressaoTipos().termo({
              html: data,
              assinante: this.impressao.assinante,
              cartorio: this.cartorio,
              selo_digital: this.impressao.selo.selo_digital,
              registroId: this.data.registro.registro_id
            })
          } 
        }

      },
      impressaoTipos () {
        const inteiroTeor = async (data) => {
          try {
            const statusImpressao = await this.callPapelSegurancaVerify()

            const verify1 = !this.papelSegurancaLote && statusImpressao.tipo == 'impressao'
            const verify2 = statusImpressao.tipo == 'impressao_rascunho'
            const verify3 = (statusImpressao.tipo == 'impressao' && Object.values(statusImpressao.papel).length > 0)

            if (verify1 || verify2 || verify3 ) {
              loader({ text: 'Gerando PDF...', active: true })

              this.impressao = {
                ...this.impressao,
                matricula: maskMatricula(this.localData.registro.matricula),
                ordemServicoSelected: this.ordemServicoSelected,
                textoImpressaoUm: data.textoUm,
                textoImpressaoDois: data.textoDois,
                tipo_impressao: statusImpressao.tipo,
                tipo_registro: this.localData.registro.tipo_registro
              }

              const urlPdf = await ImpressaoService.inteiroTeor(this.impressao)

              window.open(urlPdf)
            }

          } catch (error) {
            await this.reusePapelSeguranca()

            const message = getErrors(error)

            displayMessage('error', 'Erro ao gerar PDF.', message.message)
          } finally {
            loader({ text: '', active: false })
          }
        }

        const termo = async (data) => {
          loader({ text: 'Gerando PDF...', active: true })

          let urlPdf = await this.urlPdf(data)

          window.open(urlPdf)

          loader({ active: false })
        }

        const certidao = async () => {
          try {
            const resp = await this.$validator.validate()

            if (resp) {
              const statusImpressao = await this.callPapelSegurancaVerify()

              if (!this.papelSegurancaLote && statusImpressao.tipo == 'impressao' || statusImpressao.tipo == 'impressao_rascunho' || (statusImpressao.tipo == 'impressao' && Object.values(statusImpressao.papel).length > 0)) {
                loader({ text: 'Gerando PDF...', active: true })
                if (this.tipo == 'nascimento') {
                  this.impressao = {
                    ...this.impressao,
                    averbacoes: this.impressao.averbacao_certidao,
                    nome: this.impressao.pessoa.nome,
                    matricula: maskMatricula(this.impressao.registro.matricula),
                    ordemServicoSelected: this.ordemServicoSelected,
                    tipo_impressao: statusImpressao.tipo
                  }
                }

                if (this.tipo == 'obito') {
                  this.impressao = {
                    ...this.impressao,
                    nome: this.impressao.nome,
                    matricula: maskMatricula(this.localData.registro.matricula),
                    ordemServicoSelected: this.ordemServicoSelected,
                    tipo_impressao: statusImpressao.tipo
                  }
                }

                if (this.tipo == 'casamento') {
                  this.impressao = {
                    ...this.impressao,
                    matricula: maskMatricula(this.localData.registro.matricula),
                    ordemServicoSelected: this.ordemServicoSelected,
                    tipo_impressao: statusImpressao.tipo
                  }
                }


                const urlPdf = await this.urlPdf(this.impressao)

                window.open(urlPdf)
              //fim
              }
            } else {
              objSwal.error.title = 'Erro'
              objSwal.error.text = 'Preencha os campos obrigatórios.'
              return Swal.fire(objSwal.error).then( loader({ active: false }) )
            }

            loader({ active: false })
          } catch (e) {
            await this.reusePapelSeguranca()
            loader({ active: false, text: '' })
          }
        }

        return { termo, certidao, inteiroTeor }
      },
      async abrirModalCertidaoEletronica () {

        const objBkp = { ...objSwal.question }

        objSwal.question.confirmButtonText = 'Baixar arquivo'
        objSwal.question.cancelButtonText = 'Fechar'

        const htmlContent = objSwal.question.html 
        objSwal.question.html = `
          <div>
              <p>Para gerar a certidão eletrônica, você deve primeiro baixar o arquivo necessário.</p>
              <p>
                Depois, acesse a plataforma oficial de certidão eletrônica pelo link:<strong>
                <a href="https://certidao.registrocivil.org.br/" style="color: #074F7E;">Certidão Eletrônica</a></strong>
              </p>
          </div>
        `

        const originalIcon = objSwal.question.icon
        objSwal.question.icon = 'info'

        const originalShowDeny = objSwal.question.showDenyButton
        objSwal.question.showDenyButton = false

        const status = await Swal.fire(objSwal.question)

        objSwal.question = { ...objBkp }
        objSwal.question.html = htmlContent 
        objSwal.question.icon = originalIcon
        objSwal.question.showDenyButton = originalShowDeny

        let acao = null

        if (status.dismiss === 'cancel') {
          acao = 'fechar'
        } else if (status.value) {
          acao = 'baixar'
        }

        return acao
      },
      async gerarJson (impressao, selectMinuta) {
        try {

          let res = {}

          if (selectMinuta == "inteiro_teor_1") {

            let impressao = this.$refs.componenteInteiroTeor.impressao
            impressao.tipo_registro = this.tipo
            impressao.pessoas = this.data.registro.pessoas

            res = await CertidaoService.gerarJsonInteiroTeor(impressao, 'inteiro-teor')

          } else {

            // Tratamos as anotacoes para remover as tags do html criadas no formulario
            if (!!impressao.averbacoes_anotacoes) {
              impressao.averbacoes_anotacoes = impressao.averbacoes_anotacoes.replaceAll('<div>', '')
              impressao.averbacoes_anotacoes = impressao.averbacoes_anotacoes.replaceAll('</div>', '')
              impressao.averbacoes_anotacoes = impressao.averbacoes_anotacoes.replaceAll('nbsp;', '')
            }

            if (!impressao.averbacoes && !!impressao.averbacao_certidao) {
              impressao.averbacoes = impressao.averbacao_certidao
            }

            impressao.genitoresObject = this.localData.registro && this.localData.registro.pessoa ? this.localData.registro.pessoa.genitores : null
     
            res = await CertidaoService.gerarJsonFromResumo(impressao, this.tipo)


          }
          
          const resAdapt = JSON.stringify(res.data)

          let blob = new Blob([resAdapt], { type: 'application/json' })
          let url = window.URL.createObjectURL(blob)
          
          var a = document.createElement("a")
          document.body.appendChild(a)
          a.href = url
          a.download = selectMinuta != "inteiro_teor_1" ? `Resumo ${this.tipo + ' ' + impressao.registro.matricula}` : `Json inteiro teor ${this.tipo + ' ' + impressao.registro.matricula}`

          a.click()
          a.remove()
        } catch (error) {
          console.log('Error', error)
        }
               
      },

      async reusePapelSeguranca () {
        if (Object.values(this.modal.consumo.item).length > 0) {
          // verificamos se existe lote de papel de seguranca
          if (this.papelSegurancaLote) {
            await PapelSegurancaLoteItensService.reuseItem(this.modal.consumo.item)
            objSwal.error.title = 'Atenção'
            objSwal.error.text = 'O papel de segurança foi restaurado pois houve um erro na impressão.'
            Swal.fire(objSwal.error)
          }
        }
      },
      download (url, title) {
        var a = document.createElement("a")
        document.body.appendChild(a)
        a.href = url

        a.download = title

        a.click()
        a.remove()
      },
      async urlPdf (impressao) {
        let api = {
          termo_obito: ImpressaoService.termoObito,
          termo_nascimento: ImpressaoService.termoNascimento,
          termo_casamento: ImpressaoService.termoCasamento,
          termo_habilitacao: ImpressaoService.termoHabilitacao,
          certidao_obito: ImpressaoService.certidaoObito,
          certidao_nascimento: ImpressaoService.certidaoNascimento,
          certidao_casamento: ImpressaoService.certidaoCasamento
        }

        try {
          let minuta = null

          if (this.selectMinuta.match(/termo_/)) {
            minuta = 'termo'
          } else {
            minuta = 'certidao'
          }

          return await api[`${minuta}_${this.tipo}`](impressao)
        } catch (error) {

          if (error.response && error.response.status == 500) {
            objSwal.error.title = 'Erro'
            objSwal.error.text = 'Serviço indisponível.'
            Swal.fire(objSwal.error)
          } else {
            objSwal.error.title = 'Erro'
            objSwal.error.text = ''
            Swal.fire(objSwal.error)
          }

          loader({ active: false })
          throw new Error('Serviço indisponível', error)
        }

      },
      async visualizar (data = null) {
        console.log("Data recebido na impressao: ", data)
        console.log("this.selectMinuta: ", this.selectMinuta)
        const { groups, flag_oficial } = this.user
        let login = ''

        if (this.user) {
          login = this.user.login.split('_')[0]
        }

        if (groups && groups.length && !flag_oficial) {
          let access = false
          const permissions = [this.MINUTAS_PRE_VISUALIZACAO, this.ADMIN]

          groups.forEach(group => {
            const permission = !!group.permissions.find(permission =>
              !!permissions.includes(permission.codename)
            )
            if (permission && group.ativo) access = true
          })

          if (!access) {
            return displayMessage(
              'error',
              'Acesso negado!',
              'Você não tem permissão para acessar essa função.'
            )
          }
        } else if (login !== 'suporte' && !flag_oficial) {
          return displayMessage(
            'error',
            'Acesso negado!',
            'Você não tem permissão para acessar essa função.'
          )
        }

          const getHtmlCertidaoNormal = () => {
            const el = document.querySelector('.paste-html')
            if (!el) return null

            return el.innerHTML
              .replace(/contenteditable="true"/g, '')
              .replace(/contenteditable=""/g, '')
          }

          const getHtmlCertidaoEletronica = () => {
            const el = document.querySelector('.pagina')
            if (!el) return null

            return el.innerHTML
              .replace(/contenteditable="true"/g, '')
              .replace(/contenteditable=""/g, '')
          }

        if (!data) {
          if (this.tipo === 'habilitacao') {
            if (
              this.selectMinuta !== 'certidao' &&
              this.selectMinuta !== 'memorial_aditivo' &&
              this.selectMinuta !== 'certidao_eletronica'
            ) {
              this.$validator.validate().then(resp => {
                if (resp) {
                  this.htmlPreview = data
                  this.$bvModal.show('modal-impressao-termo')
                  return
                } else {
                  objSwal.error.title = 'Erro'
                  objSwal.error.text = 'Preencha os campos obrigatórios.'
                  return Swal.fire(objSwal.error)
                }
              })
              return
            }
            if (this.selectMinuta === 'memorial_aditivo') {
              try {
                loader({ text: 'Gerando preview...', active: true })
                this.filePreview = null

                const html = document.querySelector('.pagina-margin').innerHTML
                const pdfFile = await HabilitacaoService.getMemorialPDF(html, true)

                const blob = new Blob([pdfFile], { type: 'application/pdf' })
                this.filePreview = window.URL.createObjectURL(blob)

                this.$bvModal.show('memorial-preview')
              } catch (e) {
                console.error('Erro ao gerar preview do memorial', e)
              } finally {
                loader({ active: false })
              }
            } 
            
            //Exibir pré visualização da Certidão Eletrônica
            else if (this.selectMinuta == 'certidao_eletronica') {

              try {
                loader({ text: "Gerando preview...", active: true })
                this.filePreview = null

                let html = await this.getHtmlCertidaoEletronica()

                let htmlModificado = html.replace('margin-left: 120px;', 'margin-left: 60px;')
                const htmlComMargens = `<div style="padding-top: 50mm; padding-left: 10mm; padding-right: 10mm;"> ${htmlModificado} </div>`

                const pdfFile = await HabilitacaoService.getPdfCertidao({ html: htmlComMargens }, true)

                let blob = new Blob([pdfFile], { type: 'application/pdf' })
                let url = window.URL.createObjectURL(blob)
                this.filePreview = url

                this.$bvModal.show('modal-impressao-certidao')
              } catch (e) {
                console.error('Erro ao gerar preview da certidão', e)
              } finally {
                loader({ active: false })
              }
            }

            if (this.selectMinuta === 'certidao_eletronica') {
              console.log("IF certidao eletronica")
              try {
                loader({ text: 'Gerando preview...', active: true })
                this.filePreview = null

                console.log("Data: ", data)

                let html = null

                if (this.selectMinuta === 'certidao_eletronica') {
                  html = getHtmlCertidaoEletronica()
                } else {
                  html = getHtmlCertidaoNormal()
                }

                const pdfFile = await HabilitacaoService.getPdfCertidao(
                  { html },
                  true
                )

                const blob = new Blob([pdfFile], { type: 'application/pdf' })
                this.filePreview = window.URL.createObjectURL(blob)

                this.$bvModal.show('modal-impressao-certidao')
              } catch (e) {
                console.error('Erro ao gerar preview da certidão eletrônica', e)
              } finally {
                loader({ active: false })
              }
              return
            }
            try {
              loader({ text: 'Gerando preview...', active: true })
              this.filePreview = null

              let html = null

                if (this.selectMinuta === 'certidao_eletronica') {
                  html = getHtmlCertidaoEletronica()
                } else {
                  html = getHtmlCertidaoNormal()
                }
              const pdfFile = await HabilitacaoService.getPdfCertidao({ html }, true)

              const blob = new Blob([pdfFile], { type: 'application/pdf' })
              this.filePreview = window.URL.createObjectURL(blob)

              this.$bvModal.show('modal-impressao-certidao')
            } catch (e) {
              console.error('Erro ao gerar preview da certidão', e)
            } finally {
              loader({ active: false })
            }
          }
          return
        }

        if (data) {
          if (this.selectMinuta.match('inteiro_teor')) {
            this.impressao = {
              ...this.impressao,
              ...data
            }

            this.$bvModal.show('modal-impressao-inteiro-teor')
            return
          }
          if (
            this.selectMinuta !== 'certidao' &&
            this.selectMinuta !== 'certidao_eletronica'
          ) {
            this.$validator.validate().then(resp => {
              if (resp) {
                this.htmlPreview = data
                this.$bvModal.show('modal-impressao-termo')
                return
              } else {
                objSwal.error.title = 'Erro'
                objSwal.error.text = 'Preencha os campos obrigatórios.'
                return Swal.fire(objSwal.error)
              }
            })
            return
          }
          if (this.selectMinuta === 'certidao' && this.tipo !== 'habilitacao') {
            this.$validator.validate().then(resp => {
              if (resp) {
                this.$bvModal.show('modal-impressao-certidao')
              } else {
                objSwal.error.title = 'Erro'
                objSwal.error.text = 'Preencha os campos obrigatórios.'
                return Swal.fire(objSwal.error)
              }
            })
            return
          }

          if (this.tipo === 'habilitacao') {
            try {
              loader({ text: 'Gerando preview...', active: true })
              this.filePreview = null

              let html = null

              if (this.selectMinuta === 'certidao_eletronica') {
                html = getHtmlCertidaoEletronica()
              } else {
                html = getHtmlCertidaoNormal()
              }

              const pdfFile = await HabilitacaoService.getPdfCertidao(
                { html },
                true
              )

              const blob = new Blob([pdfFile], { type: 'application/pdf' })
              this.filePreview = window.URL.createObjectURL(blob)

              this.$bvModal.show('modal-impressao-certidao')
            } catch (e) {
              console.error(
                'Erro ao gerar preview da certidão de habilitação',
                e
              )
            } finally {
              loader({ active: false })
            }
          }
        }
      },


      async minutaLoad (data = this.selectMinuta) {
        try {
          if (data.match(/termo_/)) {
            // transforamos os registros anteriores em averbacoes
            // no momento só vamos vazer pra casamento
            if (this.tipo == 'casamento' || this.tipo === 'obito') {
              this.averbacoesPorRegistrosAnterior()
            }

            const text = data.match(/declaracao/) ? 'Carregando declaração...' : 'Carregando termo...'

            loader({text: text, active: true})
            this.html = null

            let template = data.replace(/termo_/, '') //pegando id do template do termo
            const { id } = this.$route.params

            // Fazemos os tratamentos necessarios para quando for declaração de suposto pai
            if (template.match(/declaracao/)) {
              const index = parseInt(template.replace('declaracao_', ''))

              const supostos = this.data.registro.partes.filter(parte => parte.tipo === 'SUPOSTO_PAI')

              const genitora = this.localData.registro.pessoa.genitores.find(genitor => genitor.pessoa.sexo === 'F')

              if (!genitora) {
                await displayMessage('error', 'Erro!', 'Necessário cadastrar a mãe do registrado para acessar este documento')

                this.selectMinuta = 'certidao'

                this.getSelo()
                this.minutaLoad()

                return
              }

              if (supostos && supostos.length) {
                this.parte = supostos[index]

                this.tratarTextoDeclaracaoPositiva()
              } else {
                this.tratarTextoDeclaracaoNegativa()
              }

              template = 'declaracao'
            }

            // tipos de registros que não serão atualizados a idade
            const casamento = ['D', 'C', 'CR'].includes(this.data.registro.tipo_registro)

            const post = {
              idade: !casamento ? this.updateTipoIdade() : null,
              assinantes: this.assinantes,
              cartorio: this.cartorio,
              registro: this.data.registro,
              emolumentos: this.emolumentos,
              datasExtenso: {
                data_registro: this.data.registro.data_registro ? await DataExtensoHelper.dataExtenso(this.data.registro.data_registro) : null,
                data_ocorrido: this.data.registro.data_ocorrido ? await DataExtensoHelper.dataExtenso(this.data.registro.data_ocorrido) : null,
                hora_ocorrido: this.data.registro.hora_ocorrido ? await DataExtensoHelper.horaExtenso(this.data.registro.hora_ocorrido) : null,
                data_nascimento: (!casamento && this.data.registro.pessoa.data_nascimento) ? await DataExtensoHelper.dataExtenso(this.data.registro.pessoa.data_nascimento) : null,
                data_atual: moment(this.dataAtual).format('DD [de] MMMM [de] YYYY'),
                data_transporte: this.data.registro.transporte && this.data.registro.transporte.data_transporte ? await DataExtensoHelper.dataExtenso(this.data.registro.transporte.data_transporte) : null
              },
              locaisObitoObj,
              orgaoEmissor: this.orgaoEmissor,
              sexos: {
                I: 'Ignorado',
                F: 'Feminino',
                M: 'Masculino'
              },
              selo: this.impressao.selo,
              selos: this.optionsSelos,
              averbacoes: this.impressao.averbacoes,
              assinante: this.impressao.assinante,
              texto_declarante: this.impressao.texto_declarante,
              matricula: maskMatricula(this.localData.registro.matricula),
              dados: this.impressao.dados,
              parte: this.parte,
              averbacoes_transporte: this.impressao.averbacao_transporte,
              averbacoes_livro: this.impressao.averbacao_livro,
              assinatura_declarante: this.impressao.assinatura_declarante
            }

            this.html = await ImpressaoService.getTemplate(this.tipo, { template, id, post })
          } else if (data == 'memorial_aditivo' ) {
            this.html = null

            let statusHipossuficiencia = this.data.declaracao_pobreza

            if (!this.data.declaracao_pobreza) {
              statusHipossuficiencia = true
            } else {
              this.modal.hipossuficiencia.declaracao_pobreza = 1
            }


            if (statusHipossuficiencia) {
              loader({ active: true, text: 'Carregando Memorial aditivo' })
              const params = {
                registro_id: this.localData.registro_id,
                memorial_aditivo: true,
                declaracao_pobreza: this.modal.hipossuficiencia.declaracao_pobreza
              }

              const template = await HabilitacaoService.getTemplateMemorialAditivo(this.$route.params.id, params)
              this.html = template
            }
          } else if (data == 'capa_e-habilitacao' ) {
            loader({ active: true, text: 'Carregando capa da E-Habilitação' })
            this.html = null

            /* pegando pdf pelo service */
            const pdfFile = await eHabilitacaoService.joinDocuments(this.localData, [{ tag: 'capa_sofia' }], { filtro: true })

            /* criando url blob temporária */
            let blob = base64toBlob(pdfFile.fileOutput, 'application/pdf')
            let url = window.URL.createObjectURL(blob)
            this.pdfPreview = url
          } 
          
          // Nova condição para puxar o template da minuta de certidão eletronica
          else if (data.match('certidao_eletronica')) {

            loader({ active: true, text: 'Carregando certidão eletronica' })

            // Deixa o html null por precaução, para não sobrepor outros templates carregados
            this.html = null

            // Payload replicado do arquivo responsavel por chamar a certidão (ImpressaoFormularioHabilitacao.vue)
            const payloadCertidaoEletronica = {
              habilitacao: this.localData,
              impressao: this.impressao,
              ordemServicoSelected: this.ordemServicoSelected
            }
 
            const template = await HabilitacaoService.getTemplateCertidaoEletronica(payloadCertidaoEletronica)

            // Atribuindo o template no html que será exibido no front
            this.html = template
          }
          else if (data.match('inteiro_teor')) {
            const index = data[data.length - 1]

            const procedimento = this.procedimentos[parseInt(index - 1)]

            this.$set(this.impressao, 'procedimento', procedimento)

            this.inteiroTeor = null
            this.inteiroTeor = procedimento

            this.showInteiroTeor = false
            
            setTimeout(() => {
              this.showInteiroTeor = true
            })
            
            loader({active: false})

            return
          } 
          else {
            // Tratamos o valor dos emolumentos quando o selo selecionado, quando tiver o item da OS zerado
            await this.trataEmolumentosQuandoOsTemItemZerado()
          }
        } catch (error) {
          throw new Error('Erro ao carregar template do registro', JSON.stringify(error))
        } finally {
          setTimeout(() => {
            if (data.match(/termo_/)) {
              let dnvNumberElement = document.querySelector('.dnvNumber')
              if (dnvNumberElement) {
                dnvNumberElement.innerText = this.maskDnv(dnvNumberElement.innerText)
              }
            }
          }, 100)

          loader({active: false})
        }
      },
      getSelo () {
        // Selecionamos o selo atual com base na minuta
        let selo = null

        if (this.selectMinuta.match(/termo_/)) {
          if (this.tipo == "obito") {
            selo = this.optionsSelos.find(selo => selo.tipo_ato == "AO")
          }
          if (this.tipo == "nascimento") {
            selo = this.optionsSelos.find(selo => selo.tipo_ato == "AN")
          }
        } else {
          selo = this.optionsSelos.find(selo => selo.tipo_ato == "PV")
        }

        // Validamos o selo atual da minuta. Caso exista deixamos ele como selecionado.
        if (selo) {
          this.optionSeloSelected = selo
        } else {
          // Caso não tenha nenhum selo PV, AN ou AO. Deixamos o primeiro da lista como selecionado.
          this.optionSeloSelected = this.optionsSelos.length ? this.optionsSelos[0] : null
        }

        if (this.optionSeloSelected) {
          // Pré-seleciona o primeiro selo da OS
          this.selectSelo = this.optionSeloSelected

          // Adiciona o selo pré selecionado ao obj de impressao
          this.impressao.selo.selo_digital = this.selectSelo.num_selo
          this.impressao.selo.qr_code = this.selectSelo.qr_code
        }
      },
      maskDnv (dnv) {
        if (dnv == "Não informado") {
          return dnv
        }

        let newDnv = []
        for (let i = 0; i < dnv.length; i++) {
          if (i === 2) {
            newDnv.push('-')
          }

          if (i === 10) {
            newDnv.push('-')
          }

          newDnv.push(dnv[i])
        }
        return newDnv.join('')
      },
      selectOrdemServico (emolumentos, selected) {
        this.selectSelo = {}
        this.emolumentos = emolumentos
        this.impressao.emolumentos = emolumentos

        this.optionsSelos = []

        if (selected && !!selected.itens.length) {
          selected.itens.forEach(item => {
            if (!item.seloItemOs.length) return

            item.seloItemOs.forEach(seloItem => {
              if (seloItem.selo && !seloItem.selo.cancelado_tj && !seloItem.selo.excluido_tj) this.optionsSelos.push(seloItem.selo)
            })
          })
        }

        this.ordemServicoSelected = selected

        this.optionSeloSelected = !!this.optionsSelos.length ? this.optionsSelos[0] : null

        this.getSelo()
      },
      updateHtml (html) {
        this.html = html
      },
      changeTelaImpressao (data) {
        this.tela_ordem_servico = !this.tela_ordem_servico

        this.getSelo()
        this.minutaLoad()
        this.verifyPedidoPendente()

        setTimeout(() => {
          const element = document.getElementById(!!this.optionsSelos.length ? 'optionsSelos' : 'selectMinutas')

          if (element) element.focus()
        }, 300)
      },
      zoomUpdate (type) {
        switch (type) {
        case 'plus':
          this.zoom++
          break

        case 'minus':
          this.zoom--
          break
        }
      },

      onSelectSelo () {
        this.show = false
        if (this.selectSelo) {
          this.impressao.selo.selo_digital = this.selectSelo.num_selo
        }

        setTimeout(() => {
          this.minutaLoad()
          this.show = true
        }, 200)
      },

      tratarHabilitacao () {
        if (!this.localData.registro.pessoas) return

        this.localData.registro.pessoas.map(pessoa => {
          pessoa.genitores.map(genitor => {
            const idade = moment(this.data.registro.data_ocorrido).diff(moment(genitor.data_nascimento, 'YYYY-MM-DD'), 'years')
            Object.assign(pessoa, { idade })
          })

          const idade = moment(this.data.registro.data_ocorrido).diff(moment(pessoa.data_nascimento, 'YYYY-MM-DD'), 'years')
          const data_nascimento_extenso  = DataExtensoHelper.dataExtenso(pessoa.data_nascimento)
          Object.assign(pessoa, { idade, data_nascimento_extenso })
        })
      },

      updateTipoIdade () {
        if (this.data.registro.pessoa.data_nascimento) {

          const dataNascimento = moment(this.data.registro.pessoa.data_nascimento).format('YYYY-MM-DD')

          let dataComparacao = moment()

          if (this.data.registro.data_ocorrido) {
            dataComparacao = moment(this.data.registro.data_ocorrido)
          }

          const diferenciaEmDias = moment(dataComparacao).diff(dataNascimento, 'days')
          const diferenciaEmMeses = moment(dataComparacao).diff(dataNascimento, 'months')
          const diferenciaEmAnos = moment(dataComparacao).diff(dataNascimento, 'years')

          // fazemos todas as validações em dias, pois dependendo o mês e ano o resultado do moment() não sai preciso
          if (diferenciaEmDias < 30 || diferenciaEmMeses < 1) {
            this.impressao.idade = `${diferenciaEmDias} ${diferenciaEmDias <= 1 ? 'dia' : 'dias'}`
          }

          if (diferenciaEmMeses >= 1 && diferenciaEmMeses < 12) {
            this.impressao.idade = `${diferenciaEmMeses} ${diferenciaEmMeses === 1 ? 'mês' : 'meses'}`
          }

          if (diferenciaEmAnos >= 1) {
            this.impressao.idade = `${diferenciaEmAnos} ${diferenciaEmAnos === 1 ? 'ano' : 'anos'}`
          }

          return this.impressao.idade
        } else {
          return "Não informado"
        }
      },

      async getOrgaoEmissor () {
        const orgaoEmissor = await getOrgaoEmissor()
        orgaoEmissor.map(oEmissor => {
          this.orgaoEmissor[oEmissor.codigo] = oEmissor.descricao
        })
      },

      getMinutasSupostoPai () {
        const { registro: { partes } } = this.data

        const supostosPais = partes.filter(parte => parte.tipo === 'SUPOSTO_PAI')

        if (supostosPais && supostosPais.length) {
          supostosPais.forEach((suposto, index) => {
            this.minutasNascimento.push(
              {value: `termo_declaracao_${index}`, text: `Declaração Suposto Pai ${index + 1}`}
            )
          })
        } else {
          this.minutasNascimento.push(
            {value: `termo_declaracao_1`, text: `Declaração Suposto Pai`}
          )
        }
      },
      tratarTextoDeclaracaoNegativa () {
        const genitora = this.getGenitora(this.localData.registro.pessoa.genitores)

        const {nome, nacionalidade, ocupacao_declarada, estado_civil, documentos, endereco } = genitora

        let text = ''

        text += `Eu, <b>${nome.toUpperCase().trim()}</b>`
        text += nacionalidade && nacionalidade.nome_feminino ? `, ${nacionalidade.nome_feminino}` : ''
        text += estado_civil ? `, ${this.tratarEstadoCivil(estado_civil)}` : ''
        text += ocupacao_declarada ? `, ${ocupacao_declarada}` : ''
        text += documentos && documentos.length ? `, portadora do ${this.getDocumentoIdentificacao(documentos)}` : ''
        text += endereco && endereco.logradouro ? `, residente e domiciliada em ${this.getEndereco(endereco)}` : ''
        text += endereco && endereco.cidade ? `, ${endereco.cidade || ''}, ${endereco.uf || ''}` : ''
        text += ', DECLARO que fui devidamente esclarecida sobre a possibilidade de efetuar a indicação do suposto pai de'
        text += ` <b>${this.localData.registro.pessoa.nome}</b> ${this.getDadosRegistro(this.localData.registro)}`
        text += ', nos termos do artigo 2º da Lei Federal '
        text += ' 8.560/1992, artigo 10 do Provimento 494/1993 do Conselho Superior da'
        text += ' Magistratura do Estado de São Paulo e item 42.4 do Capítulo XVII das Normas de'
        text += ' Serviço da Corregedoria Geral da Justiça do Estado de São Paulo, inexistindo, no'
        text += ' entanto, interesse em fazê-lo na presente oportunidade.'

        this.impressao.dados.texto_declaracao_negativa = text
      },
      tratarTextoDeclaracaoPositiva () {
        const genitora = this.getGenitora(this.localData.registro.pessoa.genitores)

        const {nome, nacionalidade, ocupacao_declarada, estado_civil, documentos, endereco } = genitora
        const {pessoa: {nome: nomePai, ocupacao_declarada: ocupacaoPai, endereco: enderecoPai}} = this.parte

        let text = ''

        text += `Eu, <b>${nome.toUpperCase().trim()}</b>`
        text += nacionalidade && nacionalidade.nome_feminino ? `, ${nacionalidade.nome_feminino}` : ''
        text += estado_civil ? `, ${this.tratarEstadoCivil(estado_civil)}` : ''
        text += ocupacao_declarada ? `, ${ocupacao_declarada}` : ''
        text += documentos && documentos.length ? `, portadora do ${this.getDocumentoIdentificacao(documentos)}` : ''
        text += endereco && endereco.cidade ? `, residente e domiciliada em ${endereco.cidade || ''}, ${endereco.uf || ''}` : ''
        text += endereco && endereco.logradouro ? `, ${this.getEndereco(endereco)}` : ''
        text += ', DECLARO ciente da responsabilidade civil e criminal desta declaração, conforme lhe faculta nos'
        text += ' termos do artigo 2º da Lei Federal 8.560/1992, artigo 10 do Provimento 494/1993 do Conselho'
        text += ' Superior da Magistratura do Estado de São Paulo e item 42.4 do Capítulo XVII das Normas de'
        text += ' Serviço da Corregedoria Geral da Justiça do Estado de São Paulo, que o <b>SUPOSTO PAI</b> de'
        text += ` <b>${this.localData.registro.pessoa.nome}</b> ${this.getDadosRegistro(this.localData.registro)}`
        text += `, é o Sr. <b>${nomePai}</b>`
        text += ocupacaoPai ? `, ${ocupacaoPai}` : ''
        text += enderecoPai && enderecoPai.logradouro ? `, residente e domiciliado em ${this.getEndereco(enderecoPai)}` : ''
        text += enderecoPai && enderecoPai.cidade ? `, ${enderecoPai.cidade || ''}, ${enderecoPai.uf || ''}` : ''
        text += '.'

        this.impressao.dados.texto_declaracao_positiva = text
      },
      getGenitora (genitores) {
        const genitora = genitores.find(genitor => genitor.pessoa.sexo === 'F')

        if (genitora) {
          this.impressao.dados.genitora = genitora

          return genitora.pessoa
        } else {
          displayMessage('error', 'Erro!', 'Necessário cadastrar a mãe do registrado para acessar este documento')

          return
        }
      },
      tratarEstadoCivil (estadoCivil) {
        if (['VIUVO', 'VIUVA'].indexOf(estadoCivil) !== -1) {
          estadoCivil = estadoCivil.replace('U', 'Ú')
          return estadoCivil.toLowerCase()
        } else {
          return estadoCivil.toLowerCase()
        }
      },
      tratarDocumentos () {
        if ((['C', 'CR', 'D'].indexOf(this.localData.registro.tipo_registro) !== -1)  && this.impressao.registro.anotacoes) {
          this.impressao.registro.pessoas[0].anotacoes =  this.impressao.anotacoes.filter(anotacao => anotacao.pessoa_id == this.impressao.registro.pessoas[0].pessoa_id )
          this.impressao.registro.pessoas[1].anotacoes =  this.impressao.anotacoes.filter(anotacao => anotacao.pessoa_id == this.impressao.registro.pessoas[1].pessoa_id )
          this.changeImpressao()
        }
      },
      getDocumentoIdentificacao (documentos) {
        if (!documentos || !documentos.length) return ''

        let text = ''

        const rg = documentos.find(documento => documento.tipo_documento === 'RG')
        const rne = documentos.find(documento => documento.tipo_documento === 'RNE')
        const documento = documentos[0]

        if (rg) {
          const { numero, uf_emissor } = rg

          if (uf_emissor) {
            text += `RG.${numero}/${uf_emissor}`
          } else {
            text += `RG ${numero}`
          }
        } else if (rne) {
          text += `RNE ${rne.numero}`
        } else {
          text += `${getDocumentLabel(documento.tipo_documento)} ${documento.numero}`
        }

        return text
      },
      getEndereco (endereco) {
        let text = ''
        const {logradouro, numero, complemento, bairro} = endereco

        text += logradouro ? `${logradouro}` : ''
        text += numero ? `, ${numero}` : ''
        text += complemento ? `, ${complemento}` : ''
        text += bairro ? `, ${bairro}` : ''

        return text
      },
      getDadosRegistro (registro) {
        const {livro, folha, termo} = registro

        let text = ''

        text += `(Registro no livro <b>A-${livro.num_livro || 'Não informado'}</b>`
        text += `, folha <b>${folha || 'Não informado'}</b>`
        text += `, número <b>${termo || 'Não informado'}</b>)`

        return text
      },
      displayError (title, text, html) {
        objSwal.error.title = title
        objSwal.error.text = text
        objSwal.error.html = html

        return Swal.fire(objSwal.error).then((res) => {
          objSwal.error.title = ''
          objSwal.error.text = ''
          objSwal.error.html = ''

          return res
        })
      },
      openPreviewPdf () {
        window.open(this.pdfPreview)
      },
      async getHipossuficiencia () {
        loader({ active: false, text: '' })
        const verify = (resolve) => {
          if (this.modal.hipossuficiencia.show == true) {
            setTimeout(() => {
              return verify(resolve)
            }, 2000)
          } else {
            return resolve(true)
          }
        }

        return new Promise((resolve) => {
          return verify(resolve)
        })
      },
      // verifica se esta true e fecha o modal caso esteja
      verifyHipossuficiencia () {
        if (!!this.modal.hipossuficiencia.declaracao_pobreza) {
          this.modal.hipossuficiencia.show = false
        }
      },
      async callPapelSegurancaVerify () {
        // caso a configuração de papel de seguranca esteja desativada, retornamos a impressao padrao
        if (!this.papelSegurancaLote) {
          return {
            tipo: 'impressao',
            papel: {}
          }
        }

        const objBkp = { ...objSwal.question }
        objSwal.question.title = 'Escolha o tipo de impressão:'
        objSwal.question.cancelButtonText = 'Rascunho'
        objSwal.question.confirmButtonText = 'Impressão'
        const status = await Swal.fire(objSwal.question)
        objSwal.question = { ...objBkp }

        let tipo = null

        if (status.dismiss == 'cancel') {
          tipo = 'impressao_rascunho'
        } else if (status.value) {
          tipo = 'impressao'
        }

        if (!tipo) throw 'Nenhum tipo escolhido'

        // esperando a resposta do modal de papel de segurança
        if (tipo == 'impressao') {
          await this.waitResponseSegurancaConsumo()
        }

        return {
          papel: this.modal.consumo.item,
          tipo
        }
      },
      hidePapelSegurancaConsumo (item = null) {
        this.modal.consumo.show = false

        // só é informado quando o @onHide é acionado pelo consumidor papel
        if (item) {
          this.modal.consumo.item = item
        } else {
          this.modal.consumo.item = {}
        }
      },
      async waitResponseSegurancaConsumo () {
        this.modal.consumo.show = true

        const verify = (resolve) => {
          if (this.modal.consumo.show == true) {
            setTimeout(() => {
              return verify(resolve)
            }, 2000)
          } else {
            return resolve(true)
          }
        }

        return new Promise((resolve) => {
          return verify(resolve)
        })
      },
      averbacoesPorRegistrosAnterior () {
        const tratarRegistroAnterior = (anteriores) => {
          let averbacao = ''

          for (const anterior of anteriores) {
            if (anterior.cartorio_id == this.cartorio.cartorio_id || +anterior.cns == +this.cartorio.cns) {
              // caso o registro anterior pertencer ao mesmo cartório, criamos a averbação de ANOTAÇÃO
              const { livro, folha, termo, tarefa } = anterior

              // caso tenha livro, folha e termo incluimo averbação de anotação
              if (livro && folha && termo && tarefa && tarefa.status === 'CUMPRIDA') {
                averbacao += `Anotado Livro A-${ livro }, fls. ${ folha }, nº ${ termo }.<br>`
              }
            } else if (+anterior.cns != +this.cartorio.cns) {
              // quando não for do próprio cartório criamos a averbação de COMUNICAÇÃO
              const { nome_cartorio, uf } =  anterior

              if (nome_cartorio) {
                averbacao += `Comunicado ao ORCPN de ${ nome_cartorio }${ uf ? ' - ' + uf : '' }.<br>`
              }
            }
          }

          return averbacao
        }

        let averbacao = ''

        if (this.tipo == 'casamento') {
          for (const pessoa of this.data.registro.pessoas) {
            if (pessoa.registrosAnteriores.length > 0) {
              averbacao += tratarRegistroAnterior(pessoa.registrosAnteriores)
            }
          }
        } else if (this.tipo == 'obito') {
          if (this.data.registro.anteriores.length > 0) {
            averbacao += tratarRegistroAnterior(this.data.registro.anteriores)
          }
        }
        

        // caso tenha algo na averbação
        // colocamos a cidade e a data do registro
        if (!!averbacao) {
          averbacao += `${ this.cartorio.endereco.cidade }, ${ moment(this.data.registro.data_registro).format('DD/MM/YYYY') }`
        }

        if (!this.impressao.averbacoes || (!!this.impressao.averbacoes && !this.impressao.averbacoes.match(averbacao))) {
          this.impressao.averbacoes += averbacao
        }
      },
      copyQrcodeUrl () {
        navigator.clipboard.writeText(this.selectSelo.qrcode)
      },
      hideTooltipLater () {
        setTimeout(() => {
          this.showTooltip = false
        }, 2000)
      },
      verifyTransporte (tipo) {
        if (!this.localData.registro.transporte) return 

        switch (tipo) {
        case 'obito':
          this.minutasObito.push(
            {value: `termo_transporte`, text: `Termo de Transporte`}
          )
          break

        case 'nascimento':
          this.minutasNascimento.push(
            {value: `termo_transporte`, text: `Termo de Transporte`}
          )
          break

        case 'casamento':
          this.minutasCasamento.push(
            {value: `termo_transporte`, text: `Termo de Transporte`}
          )
          break
        }
      },
      async gerarCertidao (impressao) {
        try {
          loader({text: "Gerando Certidão Eletrônica...", active: true})
          let res
          
          if (!impressao.averbacoes && !!impressao.averbacao_certidao) {
            impressao.averbacoes = impressao.averbacao_certidao
          }

          impressao.genitoresObject = this.localData.registro && this.localData.registro.pessoa ? this.localData.registro.pessoa.genitores : null
          
          if (this.tipo != 'habilitacao') {
            res = await CertidaoService.gerarCertidaoEletronica(impressao, this.tipo)
          } else {
            let htmlBase = this.html

            // Seleciona a div raiz da certidão no DOM
            const elemento = document.querySelector('.certidao-habilitacao-root')

            // Pega o texto puro do conteúdo para decidir o tamanho da fonte
            const conteudoTexto = elemento.innerText || ''

            // Pega o HTML atualizado, já com edições feitas pelo usuário
            const htmlAtualizado = elemento.innerHTML

            // Substitui o conteúdo da div raiz da certidão no HTML base,
            // mantendo a estrutura original (abertura e fechamento da div)
            // e inserindo o conteúdo atualizado no lugar.
            let htmlProcessado = htmlBase.replace(
              /(<div class="certidao-habilitacao-root">)([\s\S]*?)(<\/div>\s*<\/body>)/,
              `$1${htmlAtualizado}$3`
            )

            // Injeta estilos de impressão com font-size dinâmico
            // Se o texto for "grande", aplica padrão 11px; se for menor, aumenta para 14px
            if (conteudoTexto.length > 4000) { 
              htmlProcessado = injectPrintStyles(htmlProcessado)
            } else {
              htmlProcessado = injectPrintStyles(htmlProcessado, '14px')
            }

            /*
             Os CPFs são recebidos sem formatação (apenas números).
             Antes de renderizar o HTML, aplicamos a máscara
             XXX.XXX.XXX-XX para garantir o padrão visual correto.
            */
            const primeiraPessoaCpf = impressao.registro.pessoas[0].cpf
            const primeiraPessoaCpfTratado = primeiraPessoaCpf
              ? primeiraPessoaCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
              : ''

            const segundaPessoaCpf = impressao.registro.pessoas[1].cpf
            const segundaPessoaCpfTratado = segundaPessoaCpf
              ? segundaPessoaCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
              : ''

            htmlProcessado = htmlProcessado.replace(primeiraPessoaCpf, primeiraPessoaCpfTratado)
            htmlProcessado = htmlProcessado.replace(segundaPessoaCpf, segundaPessoaCpfTratado)

            const payload = {
              certidao: {
                plataformaId: 'certidao-eletronica',
                tipo_certidao: '',
                tipo_registro: 'casamento',
                cartorio_cns: `${impressao.cartorio.cns}`,
                selo: impressao.selo.selo_digital,
                cod_selo: impressao.selo.qr_code,
                modalidade: 'eletronica'
              },
              registro: {
                nome_completo: impressao.registro.pessoas[0].nome_antigo,
                cpf_sem_inscricao: false,
                cpf: primeiraPessoaCpfTratado,
                nome_completo_secundario: impressao.registro.pessoas[1].nome_antigo,
                cpf_secundario_sem_inscricao: false,
                cpf_secundario: segundaPessoaCpfTratado,
              },
              html: htmlProcessado
            }

            res = await CertidaoService.gerarCertidaoEletronica(payload, this.tipo)
          }

          let blob = base64toBlob(res.data.responseBase64, 'application/pdf')
          let url = window.URL.createObjectURL(blob)
          this.urlPDFCertidao = url
          this.certidaoEletronicaId = res.data.certidaoId

          this.$bvModal.show('modal-impressao-certidao-eletronica')
          //window.open(url)
        } catch (error) {
          console.log('Error', error)
          const message = getErrors(error)

          if ( error && error.response && error.response.data && error.response.data.message) {
            const message = error.response.data.message

            if (typeof message === 'string') {
              displayMessage(
                'error',
                'Erro ao gerar Certidão Eletrônica.',
                message
              )
            } else if (typeof message === 'object') {
              const erros = []
              let key
                
              for (key in message) {
                if (message.hasOwnProperty(key) && message[key] instanceof Array) {
                  let msg = message[key][0]

                  switch (key) {
                  case 'registro.nome_completo':
                    erros.push('• O campo nome completo é obrigatório')
                    break
                  case 'registro.nome_completo_secundario':
                    erros.push('• O campo nome completo secundário é obrigatório')
                    break
                  case 'registro.cpf':
                    erros.push('• O campo CPF é obrigatório')
                    break
                  case 'registro.cpf_secundario':
                    erros.push('• O CPF secundário é obrigatório')
                    break
                  default:
                    erros.push(msg)
                  }
                }
              }

              displayMessage(
                'error',
                'Erro ao gerar Certidão Eletrônica.',
                erros.join(' ')
              )
            }
          } else {
            displayMessage(
              'error',
              'Erro ao gerar Certidão Eletrônica.',
              'Tente novamente mais tarde.'
            )
          }
        } finally {
          loader({ active: false })   
        }
      },

      async assinarCertidaoEletronica (certidaoId) {
        try {
          this.$bvModal.hide('modal-impressao-certidao-eletronica')
          loader({ text: "Assinando Certidão Eletrônica...", active: true })

          const res = await CertidaoService.assinarCertidaoEletronica(
            this.tipo,
            certidaoId,
            this.data.registro.registro_id
          )

          await displayMessage('success', 'Certidão eletrônica assinada com sucesso!')

          try {
            const protocolo = await EProtocoloService.obterProtocolo (res.data.registro_id)
          
            if (protocolo && protocolo.data && protocolo.data.eProtocolo && !protocolo.data.eProtocolo.cumprido) {
              const response = await this.cumprimentoEProtocolo (res, protocolo.data.eProtocolo.hash)

              if (response && response.data && response.data.requerimento && response.data.requerimento.message === 'Ok') {
                await displayMessage('success', '', 'Protocolo cumprido com sucesso!')
              }
            }

          } catch (error) {
            let message = 'Tente novamente mais tarde.'
            const data = error.response && error.response.data

            if (data && data.error) {
              message = data.error
            } else if (data && data.success === false && data.message) {
              message = data.message
            }

            displayMessage('error', '', message)
          }

          this.localData.registro.documentoCertidaoEletronica = res.data
          if (this.propPedidoProvimento && !!this.OsComPedidoPendente) {
            const pedidoData = !!this.propPedidoProvimento ?  this.propPedidoProvimento : this.pedidoResponse
            const resultadoEnvio = await ProvimentoTrezeService.enviarPedido(
              res,
              pedidoData,
              this.impressao.emolumentos,
              this.ordemServicoSelected
            )
            displayMessage('info', resultadoEnvio.data)
          }

          if (this.propPedidoPendente && !!this.OsComPedidoPendente) {
            const pedidoData = !!this.propPedidoPendente ?  this.propPedidoPendente : this.pedidoResponse
            const resultadoEnvio = await CertidoesCRCService.enviarPedido(
              res,
              pedidoData,
              this.impressao.emolumentos,
              this.ordemServicoSelected
            )
            displayMessage('info', resultadoEnvio.data)
          }   
          window.open(res.data.link_assinatura)
          // this.reload();

        } catch (error) {
          console.log('Error', error)
          const message = getErrors(error)
          displayMessage('error', 'Erro ao assinar Certidão Eletrônica.', 'Tente novamente mais tarde.')
        } finally {
          loader({ active: false })
        }
      },

      async visualizarCertidao (certidao) {
        return window.open(certidao.link_assinatura)
      },

      async verifyPedidoPendente () {
        // Verificamos se a OS possui um pedido pendente de cumprimento
        if (this.ordemServicoSelected && !!this.ordemServicoSelected.num_pedido_crc) {
          const res = await CertidoesCRCService.obterPedidoById(this.ordemServicoSelected.num_pedido_crc)
          if (res && !!res.data ) {
            if (res.data.pedido_cumprido == 0) {
              this.pedidoResponse = res.data
              this.OsComPedidoPendente = true
            } else {
              this.OsComPedidoPendente = false
            }
          }
          else {
            let resPedidoP13 = await ProvimentoTrezeService.obterPedidoById(this.ordemServicoSelected.num_pedido_crc)
            if (resPedidoP13 && !!resPedidoP13.data ) {
              if (resPedidoP13.data.pedido_cumprido == 0) {
                this.pedidoResponse = resPedidoP13.data
                this.OsComPedidoPendente = true
              } else {
                this.OsComPedidoPendente = false
              }
            }
          }
        }
      },

      async getHtmlCertidaoEletronica () {
        try {
          const payloadCertidaoEletronica = {
            habilitacao: this.localData,
            impressao: this.impressao,
            ordemServicoSelected: this.ordemServicoSelected
          }

          let html = await HabilitacaoService.getTemplateCertidaoEletronica(payloadCertidaoEletronica)

          if (html) {
            html = html.replace(/contenteditable="true"/g, '')
          }
          return html

        } catch (e) {
          console.error('Erro ao buscar HTML da Certidão Eletrônica', e)
          throw e
        }
      },
       
      async cumprimentoEProtocolo (gerado, hash) {
        const cns = this.cartorio.cns
        const { access_token } = (await AuthService.checkIsLoggedIn()).data
        
        const headers = {
          'access-token': access_token
        }

        const payload = {
          registro_id: gerado.data.registro_id,
          certificate: {
            type: 'electronic',
            url: gerado.data.link_assinatura
          },
          responsibleUser: {
            cpf: String(this.user.cpf),
            name: this.user.nome,
            email: this.user.email,
            cns: String(cns)
          }
        }

        return await EProtocoloService.cumprirRequerimento(hash, payload, headers)
      }
    }
  }
</script>

<style scoped lang="scss">
  .Impressao {
    &--pdfPreview {
      width: 100%;
      height: 297mm;
    }
  }
  #div-seloid{
    margin-right: 5px;
  }
  #div-btn-url-qrcode{
    margin-right: auto;
  }
  #div-btn-export-certidao{
    margin-right: 5px;
  }
  #div-btn-export-certidao-v2{
    padding-left: 27%;
  }
  .CertidaoEletronica {
    border: 1px solid black;
    width: 100%;
  }

</style>
